import React from "react";

import styles from "./TagButton.module.scss";
import Icons from "../../icons";

type TagButtonProps = {
  label: string;
  type?: "primary" | "secondary" | "outline";
  onClick?: (event?: React.MouseEvent) => void;
  size?: "large" | "medium" | "small";
};

const TagButton: React.FC<TagButtonProps> = ({
  label,
  type = "primary",
  onClick,
  size = "medium",
}) => {
  const sizeClasses = {
    large: styles.large,
    medium: styles.medium,
    small: styles.small,
  };
  const variantClass = styles[type];
  const buttonClasses = `${styles.button} ${variantClass}  ${sizeClasses[size]}`;

  return (
    <button className={buttonClasses}>
      {label}
      <Icons.CrossIcon onClick={onClick} className={styles.cancelIcon} />
    </button>
  );
};

export default TagButton;
